(function () {
  function showStatus(root, message, type) {
    var status = root.querySelector("[data-ktob-contact-status]");
    if (!status) return;
    status.hidden = false;
    status.textContent = message;
    status.className =
      "ktob-contact-form__status ktob-contact-form__status--" + (type || "success");
    status.scrollIntoView({ behavior: "smooth", block: "nearest" });
  }

  function hideStatus(root) {
    var status = root.querySelector("[data-ktob-contact-status]");
    if (status) status.hidden = true;
  }

  function readBootstrap(root) {
    var el = root.querySelector("[data-ktob-contact-bootstrap]");
    if (!el) return {};
    try {
      return JSON.parse(el.textContent || "{}");
    } catch (_e) {
      return {};
    }
  }

  function formatJapanesePhoneDisplay(rawPhone) {
    if (window.ktobJpPhone && window.ktobJpPhone.displayJapanesePhone) {
      return window.ktobJpPhone.displayJapanesePhone(rawPhone);
    }
    return String(rawPhone || "").trim();
  }

  function applyDefaultPhone(phoneEl, bootstrap) {
    if (!phoneEl) return;
    var raw = phoneEl.value || bootstrap.defaultPhone || "";
    if (!raw) return;
    phoneEl.value = formatJapanesePhoneDisplay(raw);
  }

  function initContactForm(root) {
    if (!root || root.getAttribute("data-ktob-contact-form-init") === "1") return;
    root.setAttribute("data-ktob-contact-form-init", "1");

    var form = root.querySelector("[data-ktob-contact-form]");
    if (!form) return;

    var bootstrap = readBootstrap(root);
    var proxyUrl =
      root.getAttribute("data-proxy-url") || bootstrap.proxyUrl || "/apps/b2b-gate";
    var successDefault =
      root.getAttribute("data-success-message") ||
      "お問い合わせを送信しました。内容を確認のうえ、担当よりご連絡いたします。";

    var phoneEl = form.querySelector("#KtobContactPhone");
    applyDefaultPhone(phoneEl, bootstrap);

    form.addEventListener("submit", function (event) {
      event.preventDefault();
      hideStatus(root);

      var nameEl = form.querySelector("#KtobContactName");
      var emailEl = form.querySelector("#KtobContactEmail");
      var phoneEl = form.querySelector("#KtobContactPhone");
      var messageEl = form.querySelector("[data-ktob-contact-message]");
      var submitBtn = form.querySelector("[type='submit']");
      var phoneRaw = phoneEl ? String(phoneEl.value || "").trim() : "";

      var payload = {
        intent: "submit-contact",
        name: nameEl ? String(nameEl.value || "").trim() : "",
        email: emailEl ? String(emailEl.value || "").trim() : "",
        phone: phoneRaw ? formatJapanesePhoneDisplay(phoneRaw) : "",
        message: messageEl ? String(messageEl.value || "").trim() : "",
        source_page: window.location.href,
        customer_code: bootstrap.customerCode || "",
        hospital_name: bootstrap.hospitalName || "",
      };

      if (!payload.name) {
        showStatus(root, "お名前を入力してください。", "error");
        return;
      }
      if (!payload.email || payload.email.indexOf("@") === -1) {
        showStatus(root, "有効なメールアドレスを入力してください。", "error");
        return;
      }
      if (!phoneRaw) {
        showStatus(root, "電話番号を入力してください。", "error");
        return;
      }
      if (!payload.message) {
        showStatus(root, "お問い合わせ内容を入力してください。", "error");
        return;
      }

      if (submitBtn) submitBtn.disabled = true;

      fetch(proxyUrl, {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(payload),
      })
        .then(function (res) {
          return res.json().then(function (body) {
            return { ok: res.ok, body: body };
          });
        })
        .then(function (result) {
          if (!result.ok || !result.body.ok) {
            throw new Error(result.body.error || "送信に失敗しました。しばらくしてから再度お試しください。");
          }
          form.reset();
          if (nameEl && bootstrap.defaultName) nameEl.value = bootstrap.defaultName;
          if (emailEl && bootstrap.defaultEmail) emailEl.value = bootstrap.defaultEmail;
          applyDefaultPhone(phoneEl, bootstrap);
          showStatus(root, result.body.message || successDefault, "success");
        })
        .catch(function (error) {
          showStatus(root, error.message || "送信に失敗しました。", "error");
        })
        .finally(function () {
          if (submitBtn) submitBtn.disabled = false;
        });
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll("[data-ktob-contact-form-root]").forEach(initContactForm);
  });
  document.addEventListener("shopify:section:load", function (event) {
    var root = event.target.querySelector("[data-ktob-contact-form-root]");
    if (root) initContactForm(root);
  });
})();
